import { defineComponent as _defineComponent } from 'vue'
import { inject, computed, Ref, PropType } from "vue"
import { ProductTypeEnum, AHEAD_THEME } from "@/constants"
import { useAuth } from "@/store/auth/useAuth"
import Footer from "@/components/layout/Footer.vue"
import useRouter from "@/router/useRouter"
import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalStep',
  props: {
  logoUrl: {
    required: false,
    type: String,
    default: "/logo_platform.svg",
  },
  heading: {
    required: false,
    type: String,
    default: "You're all set up!",
  },
  title: {
    required: false,
    type: String,
    default: "Welcome to Peralta",
  },
  subtitle: {
    required: false,
    type: String,
  },
  showActionBtn: {
    required: false,
    type: Boolean,
    default: true,
  },
  showEmoji: {
    required: false,
    default: false,
  },
  footerLogoUrl: {
    required: false,
    type: String,
    default: "/afg_logo_01.svg",
  },
  btnLabel: { required: false, type: String, default: "Go to Peralta" },
  allowLogin: {
    required: false,
    type: Boolean,
    default: true,
  },
  userInput: {
    type: Object as PropType<{
      email: string
      password: string
    }>,
    required: false,
  },
},
  setup(__props) {

const props = __props

const productType = inject("productType", {}) as Ref<ProductTypeEnum>
const isAheadClient = computed(() => productType.value === ProductTypeEnum.Ahead)

const { login } = useAuth()

const { navigate } = useRouter()



const loggingIn = ref(false)

const onActionBtnClicked = () => {
  if (props.allowLogin) signin()
  else gotoHome()
}

const gotoHome = () => {
  navigate("/")
}

const signin = async () => {
  if (!props.userInput) return

  loggingIn.value = true
  await login({
    email: props.userInput.email,
    password: props.userInput.password as string,
  })

  loggingIn.value = false
  gotoHome()
}

return { __sfc: true,productType, isAheadClient, login, navigate, props, loggingIn, onActionBtnClicked, gotoHome, signin, AHEAD_THEME, Footer }
}

})